import React, { useState } from "react";
import { Button } from "@telia/teddy";
import _get from "lodash/get";
import { FinancingType } from "../../../../../constants";
import { GetCustomerType, ICartItem, OfferingCode } from "../../../../../models";
import { CartState } from "../../../../../models/state";
import * as Ajax from "../../../app/Ajax";
import { API_URL_ADD_PHONE } from "../../../checkout/api";

interface QueueContinueButtonProps {
    customerTypeGet: GetCustomerType;
    discountCode: string;
    financingDuration: string;
    financingType: FinancingType;
    pricePlan: OfferingCode;
    returnUrl: string;
    sku: string;
}

type AddResponse = { cart: { cart: CartState } };

const QueueContinueButton: React.FC<QueueContinueButtonProps> = ({
    sku,
    financingType,
    financingDuration,
    customerTypeGet,
    discountCode,
    pricePlan,
    returnUrl,
}) => {
    const [isLoading, setIsLoading] = useState(false);

    const saveDataAndRedirect = (
        innerSku: string,
        innerFinancingType: FinancingType,
        innerFinancingDuration: string,
        innerPricePlan: OfferingCode,
        innerDiscountCode: string,
        innerCustomerTypeGet: GetCustomerType,
    ) => {
        setIsLoading(true);
        Ajax.put<AddResponse>({
            url: API_URL_ADD_PHONE,
            data: {
                sku: innerSku,
                financingType: innerFinancingType,
                financingDuration: innerFinancingDuration,
                customerTypeGet: innerCustomerTypeGet,
                pricePlan: innerPricePlan,
                discountCode: innerDiscountCode,
            },
        })
            .then((response: AddResponse) => {
                setIsLoading(false);
                const cartContent = _get(response, "cart.cart.content", [] as ICartItem[]);
                const cartItem = cartContent.find((item) => item.id === innerSku);
                const bundleId = cartItem?.bundleId;
                const suffix = bundleId ? `&cartId=${bundleId}` : "";
                window.location.assign(`${returnUrl}${suffix}`);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <Button
            loading={isLoading}
            disabled={isLoading}
            onClick={() =>
                saveDataAndRedirect(sku, financingType, financingDuration, pricePlan, discountCode, customerTypeGet)
            }
        >
            Fortsett
        </Button>
    );
};

export default QueueContinueButton;
